import React from 'react';
import { bool, object } from 'prop-types';
import { useTranslation } from '@airasia-common/libraries/i18n';

import Wrapper from '../Wrapper';
import Row from '../Container/Row';
import Column from '../Container/Column';
import { SubBodyText } from '../Text/Heading';

import Styled from '../../utils/Styled';
import { useWindowSize } from '../../utils';
import { TEST_CLASS_NAMES } from '../../utils/constants/testing';
import DescriptionItem from './DescriptionItem';

const HeaderWrapper = Styled(Row, {
  maxHeight: 48,
  display: 'flex',
  border: '1px solid',
  borderColor: 'greyLight',
  borderTopLeftRadius: 4,
  borderTopRightRadius: 4,
  backgroundColor: 'greyLighter',
  py: 13,
  pl: 16,
});

const BodyWrapper = Styled(Row, {
  border: '1px solid',
  borderColor: 'greyLight',
  borderTop: 'none',
  borderBottomLeftRadius: 4,
  borderBottomRightRadius: 4,
  flexDirection: 'column',
  px: 4,
  pb: 4,
});

const HeaderText = Styled(SubBodyText, {
  color: 'greyDarker',
  fontWeight: 500,
});

const ItemText = Styled(SubBodyText, {
  color: 'greyDark',
});

const ChildPolicies = ({ childPolicies, childrenStayFree = false }) => {
  const translate = useTranslation();
  const { isMobileView } = useWindowSize();

  return (
    <Wrapper className={TEST_CLASS_NAMES.childPolicies.main}>
      <DescriptionItem
        label={translate('agePolicy.childrenAndExtraBeds.label')}
        content={translate('agePolicy.childrenAndExtraBeds.content')}
        pb={4}
        classNames={TEST_CLASS_NAMES.childPolicies}
      />
      {!isMobileView ? (
        <HeaderWrapper className={TEST_CLASS_NAMES.childPolicies.tableHeader}>
          <Column minWidth="24%" width="24%">
            <HeaderText>{translate('common.guestsAge')}</HeaderText>
          </Column>
          <Column>
            <HeaderText>{translate('common.policy')}</HeaderText>
          </Column>
        </HeaderWrapper>
      ) : (
        <HeaderWrapper className={TEST_CLASS_NAMES.childPolicies.tableHeader}>
          <Column>
            <HeaderText>
              {translate('agePolicy.guestsAgeAndExtraBed')}
            </HeaderText>
          </Column>
        </HeaderWrapper>
      )}

      <BodyWrapper className={TEST_CLASS_NAMES.childPolicies.tableBody}>
        {childPolicies.map((policy, index) => {
          const bucketSuffix =
            index === 1 && childrenStayFree ? '.childrenStayFree' : '';
          return policy ? (
            <Row key={policy.minAge} pt={4} flexDirection={['column', 'row']}>
              <Column minWidth={['100%', '24%']} width="24%">
                <ItemText fontWeight={[500, 400]}>
                  {translate(`agePolicy.ageRange.${index + 1}`, {
                    minAge: policy.minAge,
                    maxAge: policy.maxAge,
                  })}
                </ItemText>
              </Column>
              <Column>
                {translate(`agePolicy.title.${index + 1}${bucketSuffix}`) && (
                  <ItemText fontWeight={500}>
                    {translate(`agePolicy.title.${index + 1}${bucketSuffix}`)}
                  </ItemText>
                )}

                <ItemText>
                  {translate(
                    `agePolicy.description.${index + 1}${bucketSuffix}`
                  )}
                </ItemText>
              </Column>
            </Row>
          ) : (
            <></>
          );
        })}
      </BodyWrapper>
    </Wrapper>
  );
};

ChildPolicies.propTypes = {
  childPolicies: object,
  childrenStayFree: bool,
};

export default ChildPolicies;
